import axios from 'axios';
import { createPowerCurveStore } from './powerCurveStore';

const fetchPowerCurve = (characterName, bestWeapon) => axios
  .get('/api/external/bser/power-curve', { params: { characterName, bestWeapon } })
  .then((r) => (r.data && r.data.points) || []);

// 앱 전체(웹 카드와 PiP)가 공유하는 파워 커브 저장소
export const powerCurveStore = createPowerCurveStore(fetchPowerCurve);
